import { getUiLocaleDirection, type UiLocaleDirection } from "@/lib/i18n/uiLocale";

export type RtlPreviewVariant = "a" | "c";

export const RTL_PREVIEW_COOKIE = "te_rtl_variant";

export const RTL_PREVIEW_ENABLED = process.env.NODE_ENV !== "production";

export function parseRtlPreviewVariant(value: string | null | undefined): RtlPreviewVariant {
  if (!RTL_PREVIEW_ENABLED) return "c";
  return value === "a" ? "a" : "c";
}

export function resolvePageDirection(
  locale: string | null | undefined,
  variant: RtlPreviewVariant
): UiLocaleDirection {
  if (variant === "a") return "ltr";
  return getUiLocaleDirection(locale);
}

export function resolvePageRtlVariant(
  locale: string | null | undefined,
  variant: RtlPreviewVariant
): RtlPreviewVariant | undefined {
  return getUiLocaleDirection(locale) === "rtl" ? variant : undefined;
}
